import * as TP from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchCustomersBasicV2QueryVariables = TP.Exact<{
  filter?: TP.InputMaybe<TP.CustomersFilterV2>;
  first?: TP.InputMaybe<TP.Scalars['Int']>;
  last?: TP.InputMaybe<TP.Scalars['Int']>;
  before?: TP.InputMaybe<TP.Scalars['String']>;
  after?: TP.InputMaybe<TP.Scalars['String']>;
}>;


export type SearchCustomersBasicV2Query = (
  { readonly __typename?: 'Query' }
  & { readonly allCustomersV2?: TP.Maybe<(
    { readonly __typename?: 'CustomerConnectionV2' }
    & { readonly pageInfo: (
      { readonly __typename?: 'PageInfo' }
      & Pick<TP.PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), readonly edges: ReadonlyArray<(
      { readonly __typename?: 'CustomerEdgeV2' }
      & Pick<TP.CustomerEdgeV2, 'cursor'>
      & { readonly node: (
        { readonly __typename?: 'CustomerV2' }
        & Pick<TP.CustomerV2, 'id' | 'name' | 'code'>
      ) }
    )> }
  )> }
);


export const SearchCustomersBasicV2Document = gql`
    query searchCustomersBasicV2($filter: CustomersFilterV2, $first: Int, $last: Int, $before: String, $after: String) {
  allCustomersV2(
    filter: $filter
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useSearchCustomersBasicV2Query__
 *
 * To run a query within a React component, call `useSearchCustomersBasicV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersBasicV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersBasicV2Query({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchCustomersBasicV2Query(baseOptions?: Apollo.QueryHookOptions<SearchCustomersBasicV2Query, SearchCustomersBasicV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomersBasicV2Query, SearchCustomersBasicV2QueryVariables>(SearchCustomersBasicV2Document, options);
      }
export function useSearchCustomersBasicV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomersBasicV2Query, SearchCustomersBasicV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomersBasicV2Query, SearchCustomersBasicV2QueryVariables>(SearchCustomersBasicV2Document, options);
        }
export type SearchCustomersBasicV2QueryHookResult = ReturnType<typeof useSearchCustomersBasicV2Query>;
export type SearchCustomersBasicV2LazyQueryHookResult = ReturnType<typeof useSearchCustomersBasicV2LazyQuery>;
export type SearchCustomersBasicV2QueryResult = Apollo.QueryResult<SearchCustomersBasicV2Query, SearchCustomersBasicV2QueryVariables>;